import {
  FETCH_RESET_OPERATIONS_REQUEST,
  FETCH_RESET_OPERATIONS_SUCCESS,
  FETCH_RESET_OPERATIONS_FAILURE,
} from '../../../Constants/actionTypes';



const initialState = {
  resetOperations: [],
  userTenants: [],
  userTenant: {},
  userTempTenant: null,
  status: 'idle',
  error: null,
  loading: false,
  onSucces: false
};

const resetOperationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RESET_OPERATIONS_REQUEST:
      return {
        ...state,
        status: 'loading',
        loading: true,
        onSucces: false
      };
    case FETCH_RESET_OPERATIONS_SUCCESS:
      return {
        ...state,
        status: 'succeeded',
        resetOperations: action.payload['reset-operations'],
        userTenants: action.payload['user-tenants'] || [],
        userTenant: action.payload['user-tenant'],
        userTempTenant: action.payload['user-temp-tenant'],
        loading: false,
        onSucces: true
      };
    case FETCH_RESET_OPERATIONS_FAILURE:
      return {
        ...state,
        status: 'failed',
        error: action.payload,
        loading: false,
        onSucces: false
      };
    default:
      return state;
  }
};

export default resetOperationsReducer;
